// src/components/landing/ForStakeholders.jsx
import React from 'react';
import { useReveal } from '../../utils/reveal';
import { IconArchitect, IconBuilder, IconHome, IconBeam } from './LandingIcons';

// Each card maps to one of the app's eight account roles (accountsDb ROLES), so
// "Request access" preselects the role the visitor will register as. Every line
// describes something the product does today — the consultant card in particular
// promises the directory and messaging that exist, not the shared projects that
// do not.
const ROLES = [
  { key: 'architect', icon: IconArchitect, name: 'Architects', who: 'an architect',
    text: 'Read your existing plans into geometry, correct them by hand, and check them against the governing DCR in the same view.' },
  { key: 'builder', icon: IconBuilder, name: 'Developers & builders', who: 'a developer or builder',
    text: 'See what a plot allows before you commit to it: setbacks, FSI, coverage and height resolved from the site, with a massing built inside the envelope.' },
  { key: 'client', icon: IconHome, name: 'Homeowners', who: 'a homeowner',
    text: 'Understand what can be built on your plot, and how it sits to the sun, the wind and the Vastu, explained in plain language.' },
  { key: 'structural', icon: IconBeam, name: 'Consultants', who: 'a consultant',
    text: 'Be found by the architects and builders you work with, in a directory of role-aware profiles with messaging built in.' },
];

export default function ForStakeholders({ onRequestAccess }) {
  const ref = useReveal();
  return (
    <section id="for-you" className="lp-section lp-section--alt" aria-labelledby="lp-roles-title">
      <div className="lp-wrap">
        <h2 id="lp-roles-title" className="lp-h2">For every stakeholder</h2>
        <ul ref={ref} className="lp-roles lp-stagger">
          {ROLES.map((r, i) => {
            const Icon = r.icon;
            return (
              <li key={r.key} className="lp-card lp-role lp-glow lp-child" style={{ '--i': i }}>
                <span className="lp-icon" aria-hidden="true"><Icon /></span>
                <h3 className="lp-h3">{r.name}</h3>
                <p className="lp-body">{r.text}</p>
                <button
                  type="button" className="btn lp-role-cta"
                  onClick={() => onRequestAccess(r.key)}
                  aria-label={`Request access as ${r.who}`}
                >
                  Request access
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
